module.exports = __webpack_public_path__ + "static/media/github.40470f86.pdf";